<template>
  <div>
    <div class="wawayaya div-layout">
      <module-title title="优智多会员" />
      <div>
        <el-form
          ref="subjectSearchForm"
          class="subjectSearchForm"
          :model="searchForm"
          :inline="true"
          label-position="right"
        >
          <el-form-item label="手机号：" prop="phone">
            <el-input
              v-model="searchForm.phone"
              name="phone"
              maxlength="11"
              placeholder="输入手机号"
              class="edit-form-input"
              clearable
            />
          </el-form-item>
          <el-form-item label="业务订单号：" prop="orderNo">
            <el-input
              v-model="searchForm.orderNo"
              name="orderNo"
              maxlength="200"
              placeholder="输入业务订单号"
              class="edit-form-input"
              clearable
            />
          </el-form-item>

          <el-form-item label="来源：" prop="productCode">
            <el-select
              v-model="searchForm.productCode"
              name="equityRecordType"
              size="medium"
              class="edit-form-input"
            >
              <el-option :key="null" label="全部" :value="null" />
              <el-option
                v-for="item in equityRecordTypeList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="开通时间：" prop="createDate">
            <el-date-picker
              v-model="searchForm.createDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择开通时间"
            />
          </el-form-item>
          <el-form-item label="权益有效期时间段：" prop="dateTime">
            <el-date-picker
              v-model="dateTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="起始时间"
              end-placeholder="截至时间"
              class="edit-form-time"
              :picker-options="datePickerOptions"
              @change="handleChangeDate"
              @blur="dateBlur"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-search"
              @click="handleSearchFilter"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
        <el-table
          v-loading="listLoading"
          :data="pointsList"
          highlight-current-row
          fit
          element-loading-text="Loading"
          class="list-table"
        >
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="业务订单号" align="center" prop="srcId" />
          <el-table-column label="开通时间" prop="createDate" align="center" />
          <el-table-column label="来源" prop="productName" align="center" />
          <el-table-column label="开通手机号" prop="phone" align="center" />
          <el-table-column label="有效期始" prop="openTime" align="center" />
          <el-table-column label="有效期末" prop="expiredTime" align="center" />
        </el-table>
        <pagination
          :total="searchForm.total"
          :page.sync="searchForm.pageNum"
          :limit.sync="searchForm.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>

import { getViprecords } from '@/api/userManagement/index/';
import {
  getDictsType
} from '@/api/productOperation/public/advertisementManage';
export default {
  name: 'YzdVip',

  data() {
    return {
      dictsType: 'vip_source',
      // 搜索表单
      searchForm: {
        phone: '',
        orderNo: '',
        productCode: '',
        createDate: '',
        beginTime: '',
        endTime: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      statusList: [{
        id: '1',
        name: '有效'
      },
      {
        id: '0',
        name: '无效'
      }],
      pointsList: [],
      equityRecordTypeList: [],
      listLoading: false, // 表格刷新loading
      dateTime: '',
      startDate: '',
      datePickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.startDate = minDate.getTime();
        },
        disabledDate: (time) => {
          const one = 3 * 30 * 24 * 3600 * 1000;
          if (this.startDate !== '') {
            const maxTime = this.startDate + one;
            const minTime = this.startDate - one;
            return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now() - 8.64e6;
          } else {
            return time.getTime() > Date.now() - 8.64e6;
          }
        }
      }
    };
  },
  mounted() {
    this.getType();
    this.fetchPointsList();
  },
  methods: {
    dateBlur() {
      this.startDate = '';
    },
    getType() {
      getDictsType(this.dictsType).then(res => {
        this.equityRecordTypeList = res.data;
      });
    },
    // 获取积分明细数据
    fetchPointsList() {
      this.listLoading = true;
      var option = {
        phone: this.searchForm.phone,
        orderNo: this.searchForm.orderNo,
        productCode: this.searchForm.productCode,
        createDate: this.searchForm.createDate,
        beginTime: this.searchForm.beginTime,
        endTime: this.searchForm.endTime,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize

      };
      getViprecords(option).then((res) => {
        if (res.data && res.data.list && res.data.list.length) {
          this.pointsList = res.data.list;
          this.searchForm.total = res.data.total;
        } else {
          this.pointsList = [];
          this.searchForm.total = 0;
        }
        this.listLoading = false;
      }).catch((err) => {
        console.log(err);
        this.pointsList = [];
        this.total = 0;
        this.listLoading = false;
      });
    },
    handleChangeDate(val) {
      if (val && val.length > 0) {
        this.searchForm.beginTime = val[0];
        this.searchForm.endTime = val[1];
        this.fetchPointsList();
      } else {
        this.searchForm.beginTime = '';
        this.searchForm.endTime = '';
      }
      this.dateBlur();
    },
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchPointsList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchPointsList();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchPointsList();
    }
  }
};
</script>
<style lang="scss" scoped>
.wawayaya {
  // padding-top: 10px;
  .subjectSearchForm{
    padding: 0 20px;
  }
}
.edit-form-input {
  // width: 150px;
}
.edit-form-time{
   width: 300px;
}
</style>
